/* eslint-disable import/prefer-default-export */
import store from '@/store'
import { getData } from '@core/utils/http/general'

export const useEcommerce = () => {
  // Obtiene los ciclos escolares disponibles para agendar el alumno
  const cicloEscolarDisponible = () => new Promise((resolve, reject) => {
    getData({ action: 7 })
      .then(response => {
        if (response.status === 500 && response.data.status === 500) reject(response.data.message)
        else resolve(response.data)
      })
      .catch(err => { reject(err) })
  })

  // Obtiene el listado de artículos disponibles para el alumno, en base a filtros
  const fetchShopItems = filters => store.dispatch('eCommerce/loadShopItems', filters)

  return {
    cicloEscolarDisponible,
    fetchShopItems,
  }
}
